import { Button } from '@material-ui/core';
import { useCallback, useEffect } from 'react';
import { useRef } from 'react';
import { useState } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { OtpField, ResendOtp, useTimer } from '../../../../lib/OtpField';
import { verifyOtp } from '../../../../redux-store/actions/login';
import { sendPhoneOTP, transmissionUnits } from '../../../../redux-store/actions/nct';
import { OTP_RESPONSE, VerifyOtpPayload } from '../../../../redux-store/types/login';
import { SEND_PHONE_OTP_PAYLOAD } from '../../../../redux-store/types/nct';
import { OTP_ACTIONS } from '../../../../utils/constants';
import { maskMobileNumber } from '../../../../utils/utilityFunctions';
import { HistoryStateProps } from './list';
import en from '../../../../lang/en-us';
import { RootStateType } from '../../../../redux-store/reducers';
import { ActionHeader } from '..';
import { SubmitButtonWithLoader } from '../../../../lib/Button';
import OtpSentTextWrapper from '../../../../lib/OtpSentTextWrapper';
const { dashboard } = en;

interface TransmissionOTPProps extends RouteComponentProps<any, any, HistoryStateProps> {
    sendPhoneOTP: (body: SEND_PHONE_OTP_PAYLOAD) => Promise<any>;
    verifyOtp: (body: VerifyOtpPayload) => Promise<any>;
    transmissionUnits: (body: any) => Promise<any>;
    mobile: string;
    pan: string;
    pekrn: string;
    otpRef: string;
    reqId: string;
    imageInfo: any;
    isLoggedInViaMobile: boolean;
    userRegisteredWith: string;
    email: string;
}

function PostTransmissionRequestOtp(props: TransmissionOTPProps) {
    const [otpInput, setOtpInput] = useState<string[]>(new Array(6).fill(''));
    const otpRefInfo = useRef<OTP_RESPONSE | null>(null);
    const { startTimer, resetTimer, timer, stopTimer } = useTimer({});
    const { mobile, pan, pekrn } = props;
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (!props.location.state) {
            return props.history.push('/');
        }
        sendOtp();
    }, []);

    const sendOtp = useCallback(() => {
        async function callApi() {
            try {
                const payload = {
                    pan,
                    mobile,
                    pekrn,
                    action: OTP_ACTIONS.TRANSMISSION_OF_UNITS,
                };
                let { body = {} } = await props.sendPhoneOTP(payload);
                otpRefInfo.current = body;
            } catch (err: any) {
                alert(err.message);
            }
        }
        callApi();
    }, [mobile]);

    const handleSubmit = async () => {
        stopTimer();
        setLoading(true);
        try {
            const payload: VerifyOtpPayload = {
                enteredOtp: otpInput.join(''),
                otpRef: otpRefInfo.current?.otpRef || '',
                reqId: otpRefInfo.current?.reqId || '',
                pan,
                pekrn,
                mobile,
                action: OTP_ACTIONS.TRANSMISSION_OF_UNITS,
            };
            await props.verifyOtp(payload);
            transmissionOfUnits();
        } catch (err: any) {
            alert(err.message);
            setOtpInput(new Array(6).fill(''));
        } finally {
            setLoading(false);
        }
    };

    const transmissionOfUnits = async () => {
        try {
            const { imageInfo } = props;
            const { deceasedPersonPAN = '', targetFunds = [] } = props.location.state;
            const modifiedData = targetFunds.map((fund) => ({
                amc: fund.amc,
                folio: fund.id.toString(),
                deceasedPan: deceasedPersonPAN,
                holderPosition: fund.holderPosition.toString(),
            }));
            const modifiedImageInfo = imageInfo.data.map((image: any) => {
                const { format, ...rest } = image;
                return {
                    ...rest,
                    extension: format,
                };
            });
            const payload = {
                reqId: otpRefInfo.current?.reqId || '',
                pan,
                mobile,
                pekrn,
                images: modifiedImageInfo,
                data: modifiedData,
                documents:
                    'T-1 Form, Copy of Death Certificate, Nomination Form, Bank Mandate Form',
            };
            let res = await props.transmissionUnits(payload);
            props.history.replace('transmission-request-success', {
                ...props.location.state,
                ...(res || {}).body,
            });
        } catch (err: any) {
            alert(err.message);
        }
    };

    const onResend = () => {
        sendOtp();
        resetTimer();
    };
    return (
        <div className="curved-bg">
            <ActionHeader header={dashboard.TransmissionRequest.TransmissionRequestHeading} />
            <div className="curved-bg-content">
                <img className="change-email-img" src="/images/change-otp-img.png" alt="" />
                <div className="curved-bg-content-inner">
                    <div className="curved-bg-content-inner-top">
                        <h3 className="subheading">
                            {dashboard.OtpScreen.subHeading}
                            <span>{dashboard.OtpScreen.subHeadingSpan}</span>
                        </h3>
                        <OtpSentTextWrapper
                            userRegisteredWith={props.userRegisteredWith}
                            mobile={maskMobileNumber(mobile)}
                            email={props.email}
                        />
                        <OtpField
                            value={otpInput}
                            updateValue={(otp: string[]) => {
                                setOtpInput(otp);
                            }}
                        />
                    </div>
                    <div className="curved-bg-content-inner-bottom">
                        <SubmitButtonWithLoader
                            disabled={otpInput.join('').length !== 6}
                            loading={loading}
                            label={dashboard.OtpScreen.buttonText}
                            labelWhileLoading={dashboard.OtpScreen.buttonTextWhileLoading}
                            onClick={handleSubmit}
                        />
                        <ResendOtp counter={timer} onResendOtp={onResend} startTimer={startTimer} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(
    ({ authReducer, portfolio }: RootStateType) => ({ ...authReducer, ...portfolio }),
    {
        sendPhoneOTP,
        verifyOtp,
        transmissionUnits,
    },
)(PostTransmissionRequestOtp);
